import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Grid, GridItem, HStack } from '@chakra-ui/react';
import { Children } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function List(props) {
  var listItems = Children.toArray(props.children);
  var renderItem = (listItem, idx) => {
    return _jsx(GridItem, {
      children: _jsxs(HStack, {
        spacing: "1rem",
        children: [props.icon, _jsx(Box, {
          children: listItem
        })]
      })
    }, idx);
  };
  return _jsx(Grid, _objectSpread(_objectSpread({
    templateColumns: "repeat(".concat(props.cols, ", 1fr)"),
    gap: 4
  }, props), {}, {
    children: listItems.map(renderItem)
  }));
}
List.defaultProps = {
  cols: 1
};